import Repository from '@/api/Repository'

const resource = '/action'

export default {
  index(data) {
    return Repository.get(resource, {
      data,
    })
  },
  show(id) {
    return Repository.get(resource + '/' + id)
  },
  update(id, data) {
    return Repository.put(resource + '/' + id, data)
  },
  create(data) {
    return Repository.post(resource, data)
  },
  delete(id) {
    return Repository.delete(resource + '/' + id)
  },
  getList() {
    // List<String> action
    return Repository.get('enum/object-action')
  }
}
